module.exports = __webpack_public_path__ + "img/bs3.db575523.png";